<template>
    <li>
        <div class="title"><span>オンライン/WEB</span></div>
        <div class="detail">
            <input type="text" class="edit-pen _url" maxlength="250" placeholder="https:// もしくは http:// からご入力ください" v-model="web_url" v-bind:class="{ '_error _required':  $store.state.register.errors.web_url }">
            <span style="color: red" v-if="$store.state.register.errors.web_url">必須項目を入力してください</span>
        </div>
    </li>
</template>

<script>

export default {
    data() {
        return {
            web_url: '',
        };
    },
    created() {
        // 編集の場合
        if (this.$store.state.detail.set.brand.web_url) {
            this.web_url = this.$store.state.detail.set.brand.web_url;
            this.$store.state.register.form.web_url = this.$store.state.detail.set.brand.web_url;
        }
    },
    watch: {
        web_url: function (value) {
            this.$store.state.register.form.web_url = value;
        }
    }
};
</script>